// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { FormTokens } from './type';

const formTokens: FormTokens = {
  formItemFontSize: 'Font-14',
  formItemFontColor: 'Neutral-text-5',
  formItemTooltipIconColor: 'Neutral-text-4',
  formItemTooltipIconFontSize: 'Font-14',
  formItemTooltipIconMarginXStart: 'Spacing-4',
  formItemMarginYEnd: 'Spacing-12',
  formItemMarginXEnd: 'Spacing-16',
  formItemLabelWidth: '140px',
  formItemLabelPaddingY: 'Spacing-5',
  formItemLabelMarginXEnd: 'Spacing-8',
  formItemLabelTopPaddingY: 'Spacing-4',
  formItemLabelFontWeight: 'Weight-regular',
  formItemLabelFontColor: 'Neutral-text-5',
  formItemDangerFontSize: 'Font-12',
  formItemDangerFontColor: 'Danger-6',
  formItemDangerFontWeight: 'Weight-regular',
  formItemTipMinHeight: 'Size-10',
  formItemTipFontSize: 'Font-12',
  formItemTipFontColor: 'Neutral-text-3',
  formItemTipFontWeight: 'Weight-regular',
  formItemTipMarginTop: 'Spacing-0',
};

export default formTokens;
